<template>
  <div id="messageForm" class="h-full">
    <el-form
      :model="messageSetting"
      :rules="messageRules"
      ref="messageSetting"
      label-width="100px"
      style="width: 500px; margin: 0 auto"
      size="small"
      :disabled="!!taskId"
    >
      <el-form-item :label="$t('通知设置')" prop="noticeSettings">
        <el-select
          class="w-100"
          v-model="messageSetting.noticeSettings"
          @change="isDiabledMsg"
          :placeholder="$t('请选择通知设置')"
          filterable
          clearable
        >
          <el-option
            v-for="item in noticeSettingList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('通知方式')" prop="type">
        <el-select
          class="w-100"
          v-model="messageSetting.type"
          :placeholder="$t('请选择通知方式')"
          filterable
          clearable
        >
          <el-option
            v-for="item in noticeTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('通知标题')" prop="title">
        <el-input
          v-model="messageSetting.title"
          :placeholder="$t('请输入标题')"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('通知接收人')" prop="recipient">
        <el-input
          v-model="messageSetting.recipient"
          :placeholder="$t('多个人以逗号分隔')"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('通知描述')" prop="content">
        <el-input
          v-model="messageSetting.content"
          :placeholder="$t('请输入描述内容')"
          type="textarea"
          rows="3"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('发送日志')" prop="isSendDetails">
        <el-checkbox v-model="messageSetting.isSendDetails"></el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'messageForm',
  props: {
    messageSetting: Object,
    taskId: String,
  },
  data() {
    return {
      noticeTypeList: [{ id: 0, name: '邮箱' }],
      noticeSettingList: [
        { id: 0, name: '启动' },
        { id: 1, name: '异常时发送' },
        { id: 2, name: '禁用' },
      ],
      messageRules: {
        noticeSettings: [{ required: true, message: '通知设置不能为空', trigger: 'blur' }],
        type: [{ required: false, message: '通知方式不能为空', trigger: 'blur' }],
        title: [{ required: false, message: '通知标题不能为空', trigger: 'blur' }],
        recipient: [{ required: false, message: '接收人不能为空', trigger: 'blur' }],
      },
    }
  },
  computed: {},
  watch: {
    'messageSetting.noticeSettings': {
      deep: true,
      handler(newVal) {
        this.isDiabledMsg(newVal)
      },
    },
  },
  methods: {
    // 消息设置是否选的禁用，如果禁用，则通知方式、标题、接收人非必填
    isDiabledMsg(value) {
      const flag = value === 2
      if (flag) {
        this.messageRules.type[0].required = false
        this.messageRules.title[0].required = false
        this.messageRules.recipient[0].required = false
      } else {
        this.messageRules.type[0].required = true
        this.messageRules.title[0].required = true
        this.messageRules.recipient[0].required = true
      }
    },
  },
}
</script>
